import { blue } from '@mui/material/colors';

export const DEFAULT_LIST_COLOR = blue[500];
